import { createApp, h } from 'vue'
import RightsUsers from '~/components/RightsUsers.vue'

export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.vueApp.directive('check-rights', {
        mounted (el, binding) {
            const options = binding.value

            if (!options) {
                return
            }

            if (!options.type) {
                options.type = 'edit'
            }
            if (!options.id) {
                options.id = 0
            }

            const { $axios, $i18n, $vuetify } = nuxtApp

            $axios.get(`/be/rights/${options.type}/${options.module}/${options.id}`).then((res) => {
                
                if (res.data.status) {
                    const eventTypes = ['click']
                    
                    if (el.classList.contains('v-btn') && !el.classList.contains('v-btn--icon')) {
                        Object.keys(el.children).forEach(key => {
                            if(el.children[key].classList.contains('v-btn__content')) {
                                el.children[key].textContent = $i18n.t('app.noRightsBtn')
                            }
                        })
                        el.classList.remove('bg-primary')
                        el.classList.add('bg-red-lighten-1')
                    } else if (el.classList.contains('v-tab')) {
                        // Tab handling for Vue 3
                        // el.classList.add('v-tab--disabled')
                    }

                    const handler = (e) => {
                        e.stopImmediatePropagation()
                        e.preventDefault()

                        const container = document.querySelector('[data-app=true]') || document.body
                        return new Promise((resolve) => {
                            const mountNode = document.createElement('div')
                            container.appendChild(mountNode)

                            const app = createApp({
                                render: () => h(RightsUsers, {
                                    module: options.module,
                                    i18n: $i18n,
                                    id: options.id,
                                    type: options.type,
                                    onDestroyed: () => {
                                        app.unmount()
                                        container.removeChild(mountNode)
                                        resolve()
                                    }
                                })
                            })

                            // Provide global properties
                            app.config.globalProperties.$i18n = $i18n
                            if ($vuetify) {
                                app.use($vuetify)
                            }

                            app.mount(mountNode)
                        })
                    }

                    eventTypes.forEach((type) => {
                        el.addEventListener(type, handler, true)
                    })
                }
            })
        }
    })
})
